import React from 'react'

export default function Dashboard() {
  return (
    <div className="container-fluid">
      <h3>Teertham Dashboard</h3>
    </div>
  )
}
